module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('span', {
    attrs: {
      "id": "copyright"
    }
  }, [_vm._v("\t©" + _vm._s(_vm.year) + " Salesforce.com")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bd3ca22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/DashboardFooter.vue
// module id = 146
// module chunks = 0